import type { StripeCustomerData } from '../../repositories';

type StripePaymentMethodData = NonNullable<StripeCustomerData['paymentMethod']>;

export enum StripeCreditCardType {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  DISCOVER = 'discover',
}

export class StripePaymentMethod {
  constructor(private readonly values: StripePaymentMethodData) {}

  public toJson() {
    return this.values;
  }

  public getType() {
    return this.values.type;
  }

  public getCard() {
    if (this.values.type !== 'card') {
      return null;
    }

    return this.values.card;
  }

  public getToken() {
    return this.values.id;
  }
}
